import { inject, Injectable } from "@angular/core";
import { HttpService } from "../../core/services";

@Injectable({
  providedIn: 'root'
})
export class CalendarIntegrationApi {
  private readonly httpService = inject(HttpService);

  list() {
    return this.httpService.get('calendar/integrations', false);
  }

  upsert(payload: any) {
    return this.httpService.post('calendar/integrations', payload, false);
  }

  disconnect(provider: string) {
    return this.httpService.delete(`calendar/integrations/${provider}`, false);
  }
}

